import { Record } from 'immutable';

interface IIntegerRange {
  min?: number | null;
  max?: number | null;
}

export type IntegerRange = Record<IIntegerRange>;
// Record returns a class type, which creates a runtime variable and identifier in the namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IntegerRange = Record<IIntegerRange>({ min: undefined, max: undefined }, 'IntegerRange');

export const IntegerRangeMarshaller = {
  deserialize: (integerRangeData: IIntegerRange) => new IntegerRange(integerRangeData),
  serialize: (integerRange: IntegerRange) => integerRange.toJSON(),
};
